import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { faMagnifyingGlass, faChevronRight, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import {ContentService} from "../../../data-access/content.service";
import {Subject} from "../subjectList/subjectList.component";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface OnInit {
  ngOnInit(): void
}

interface node {
  name: string,
  subject_id: number,
  customcontentlayer_children: number,
  customcontentlayer_id: number,
  createdate?: Date,
  last_updated?: Date
  expanded: boolean
}

@Component({
    selector: 'CCLTree',
    templateUrl: './cclTree.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class CCLTreeComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute, private contentService: ContentService) {
  }
  errorText = ""
  errorDialog = false
  isLoading = false
  faChevronRight = faChevronRight
  faRotateLeft = faRotateLeft
  faMagnifyingGlass = faMagnifyingGlass
  isOpened = true
  subjectList: Subject[] = []
  subjectID = ""
  parentNode: node | null = null
  childNodes: node[] = []
  backNodes: node[] = []
  parentSubjectID = -1
  searchText = ""
  iconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; flex-shrink: 1;`
  underlineStyle = `color: ${localStorage.getItem('primaryColor')}; text-decoration-line: underline; font-size: 0.875rem; line-height: 1.25rem;`
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Subject List',
    route: 'dashboard/ContentViewer/SubjectList'
  }]
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.subjectID = params['subject_id']
      this.contentService.getAllSubjects().subscribe((response) => {
        if(response.success) {
          this.subjectList = response.result
          for(let subject of this.subjectList) {
            this.parentSubjectID = subject.subject_id
            if(subject.subject_id.toString() === this.subjectID) {
              this.parentNode = {
                name: subject.name,
                subject_id: subject.subject_id,
                customcontentlayer_id: -1,
                customcontentlayer_children: response.result.customcontentlayer_children,
                createdate: response.result.createdate,
                last_updated: response.result.last_updated,
                expanded: false
              }
            }
          }
        } else {
          this.errorDialog = true;
          this.errorText = response.msg
        }
      })
      this.contentService.listCCLChildren(Number(this.subjectID), -1).subscribe((response) => {
        if(response.success) {
          for(let item of response.result) {
            this.parentSubjectID = item.subject_id
            this.childNodes.push({
              name: item.name,
              subject_id: item.subject_id,
              customcontentlayer_children: item.customcontentlayer_children,
              customcontentlayer_id: item.customcontentlayer_id,
              createdate: item.createdate,
              last_updated: item.last_updated,
              expanded: false
            })
          }
        } else if(response.msg !== "no custom content layers found") {
          this.errorDialog = true;
          this.errorText = response.msg
        }
      })
    })
  }

  SubjectList() {
    this.router.navigate(['dashboard/ContentViewer/SubjectList'])
  }

  changeParentNodeSubject(subject: Subject) {
    this.childNodes = []
    this.backNodes = []
    this.parentSubjectID = subject.subject_id
    this.parentNode = {
      name: subject.name,
      subject_id: subject.subject_id,
      customcontentlayer_id: -1,
      customcontentlayer_children: 0,
      expanded: true
    }
    this.contentService.listCCLChildren(subject.subject_id, -1).subscribe((response) => {
      if(response.success) {
        for(let item of response.result) {
          this.childNodes.push({
            name: item.name,
            subject_id: item.subject_id,
            customcontentlayer_children: item.customcontentlayer_children,
            customcontentlayer_id: item.customcontentlayer_id,
            createdate: item.createdate,
            last_updated: item.last_updated,
            expanded: false
          })
        }
      } else if(response.msg !== "no custom content layers found") {
        this.errorDialog = true;
        this.errorText = response.msg
      }
    })
  }
  leanringObjectiveClick(ccl_id: number) {
    console.log(this.parentNode)
    if(ccl_id != null && ccl_id !== -1) {
      this.router.navigate(['dashboard/ContentViewer/SubjectList/CCLTree/LearningObjectives'], {queryParams: {subject_id: this.parentNode?.subject_id, ccl_id: ccl_id}})
    } else {
      this.router.navigate(['dashboard/ContentViewer/SubjectList/CCLTree/LearningObjectives'], {queryParams: {subject_id: this.parentNode?.subject_id}})
    }
  }

  changeParentNode(node: node) {
    this.parentNode = node
    this.childNodes = []
    this.contentService.listCCLChildren(node.subject_id, node.customcontentlayer_id).subscribe((response) => {
      if(response.success) {
        for(let item of response.result) {
          this.childNodes.push({
            name: item.name,
            subject_id: item.subject_id,
            customcontentlayer_children: item.customcontentlayer_children,
            customcontentlayer_id: item.customcontentlayer_id,
            createdate: item.createdate,
            last_updated: item.last_updated,
            expanded: false
          })
        }
      } else if(response.msg !== "no custom content layers found") {
        this.errorDialog = true;
        this.errorText = response.msg
      }
    })
  }

  goBackOneNode(node: node) {
    this.backNodes.pop()
    this.changeParentNode(node)
  }

  goForwardOneNode(nextNode: node, currentNode: node | undefined | null) {
    if(currentNode != null)
      this.backNodes.push(currentNode)
    this.changeParentNode(nextNode)
  }
}
